import { APP_URL, AUTH_URL, CLIENT_ID, SCOPE_ID } from "./environment";

export const OIDCConfig = {
	authority: AUTH_URL,
	client_id: CLIENT_ID,
	grant_type: "authorization_code",
	response_type: "code",
	loadUserInfo: true,
	scope: `openid profile ${SCOPE_ID}`,
	redirect_uri: APP_URL,
};